import * as I from "immutable";

import {splitAddress} from "utils";
import {House} from "v2/api/Records";
import {apiTimeConstraint} from "v2/api/TimeConstraints";
import {apiUser} from "v2/api/Users";

export const apiHouse = (house) => {
  const [address, city, state, zipCode] = splitAddress(house.formattedAddress);
  return new House({
    ...house,
    address,
    customer: apiUser(house.user),
    city,
    fullAddress: house.formattedAddress,
    latitude: Number(house.latitude),
    longitude: Number(house.longitude),
    state,
    timeConstraints: I.List((house.timeConstraints || []).map(apiTimeConstraint)),
    zipCode,
  });
};

export default {
  apiHouse,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Houses.js
 **/